export default {
    fundings: [],
    fundingsDetail: {},
    addFundingModal: false,
    companies: [],
    companyNames: [],
    exportTotalCount: null,
    fundingsRG: []
}
